/**
 * Utility functions for state management and serialization
 */

/**
 * Serialize a Set to an array for storage
 */
export function serializeSet<T>(set: Set<T>): T[] {
  return Array.from(set);
}

/**
 * Deserialize an array back to a Set
 */
export function deserializeSet<T>(value: T[] | null | undefined): Set<T> {
  if (!value || !Array.isArray(value)) {
    return new Set();
  }
  return new Set(value);
}

/**
 * Remove undefined, null, and empty string values from an object
 * Useful for cleaning URL parameters before setting them
 */
export function cleanObject<T extends Record<string, any>>(obj: T): Partial<T> {
  const cleaned: Partial<T> = {};

  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined && value !== null && value !== "") {
      cleaned[key as keyof T] = value;
    }
  }

  return cleaned;
}

/**
 * Parse a query parameter value to a specific type
 */
export function parseQueryParam(
  value: string | null | undefined,
  type: "string" | "number" | "boolean",
): string | number | boolean | undefined {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  switch (type) {
    case "string":
      return value;
    case "number": {
      const num = Number(value);
      return isNaN(num) ? undefined : num;
    }
    case "boolean":
      return value === "true" || value === "1";
    default:
      return value;
  }
}
